import React from 'react'

import CheckBox from '@/shared/components/modal/CheckBox'
import { Text } from '@/shared/components/typography/index'

type ConfirmProps = {
  bodyText: React.ReactNode //바디 텍스트
  onChangeCheckbox?: (e: React.ChangeEvent<HTMLInputElement>) => void
  checkText?: string
  disabled?: boolean
  checked?: boolean
  className?: React.ComponentProps<'div'>['className']
}

const Confirm = ({ bodyText, onChangeCheckbox, checkText, disabled, checked, className = '' }: ConfirmProps) => {
  return (
    <div>
      <Text level="text2" color="text090" weight="regular" className={`${className}`}>
        {bodyText}
      </Text>
      {checkText && <CheckBox onChange={onChangeCheckbox} text={checkText} disabled={disabled} checked={checked} />}
    </div>
  )
}

export default Confirm
